<template>
  <div id="q-app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import { createMeta } from 'src/utils/meta';
import fullDineInMixin from 'src/pages/mixin/fullDineInMixin';


// eslint-disable-next-line import/order
import {
  storeBlackList,
  TABLE_CHANGE_SUCCESS_POPUP_PAGES,
} from './utils/config';


export default {
  name: 'App',
  mixins: [fullDineInMixin],
  preFetch({ currentRoute, store, redirect }) {
    const storeName = currentRoute.params.store;
    if (!storeName || storeBlackList.includes(storeName)) {
      return redirect('/page/Error404');
    }
    return Promise.all([
      store.dispatch('prefetch/prefetchStoreInfo', { currentRoute, redirect }),
      store.dispatch('prefetch/prefetchSEO', { currentRoute, redirect }),
    ]);
  },
  meta() {
    return createMeta(this);
  },
};
</script>
<script setup>
import Vue, {
  provide,
  ref,
  nextTick,
  onMounted,
  defineExpose,
  onBeforeMount,
  onBeforeUnmount,
  watch,
} from 'vue';

import { MyIcons } from 'src/utils/icon/index.js';
import { debounce } from 'quasar';
import { useRoute } from './utils/v2_helper/router';
import { showDialog } from './utils/error_config';
import {
  clearCartTableId,
  clearTable,
  getTable,
  setTable,
} from './utils/common';
import { getUserInfo } from './api/login';
import { useIns, useStore } from './utils/v2_helper/common';


const app = useIns();
const store = useStore();
const route = useRoute();

const isRouterAlive = ref(true);

async function reload() {
  isRouterAlive.value = false;
  await nextTick();
  isRouterAlive.value = true;
}
function initUser() {
  const token = localStorage.getItem('token');
  if (token) {
    getUserInfo().then((res) => {
      store.dispatch('Menu/setUserInfo', res.data || {});
    });
  }
}

function initIcon() {
  app.$q.iconMapFn = (iconName) => {
    // iconfont 字体图标
    if (iconName.startsWith('font:') === true) {
      const name = iconName.substring(5);
      return {
        cls: `iconfont ${name}`,
      };
    }
    // 图片图标：只可修改大小
    if (iconName.startsWith('app:') === true) {
      const icon = MyIcons[iconName];
      if (icon !== void 0) {
        return { icon };
      }
    }
    // svg图标：可修改大小和颜色
    if (iconName.startsWith('svg:') === true) {
      return {
        icon: `svguse:#icon-${iconName.split(':')[1]}`,
      };
    }
  };
}
function initFullStory() {
//  if (process.env.CLIENT && app.userInfo?.id && window.FS) {
//    window.FS.identify(app.userInfo.id, {
//      displayName: app.userInfo.phone,
//      email: app.userInfo.email,
//      nickname_str: app.userInfo.nickName,
//    });
//  }
}


const _showDialog = debounce(showDialog, 300);
// 注册全局FullDineIn换桌成功订阅
function registerFullDineInTableChange() {
  setTimeout(() => {
    if (!getTable() || !app.storeInfo?.fullDineIn) return;
    console.log('[[REGISTER_FULLDINE_CHANGE_TABLE]]');
    app.onGlobalSubscribKey('change-table', (data) => {
      console.log('[[GLOBAL_SUBSCRIB_cart]]', data);
      const { newTable } = data;
      const TABLE_CHANGED_FALG = { success: 8004, clear: 8005 };
      const { table } = route.query;
      if (table && newTable) {
        window.history.pushState({}, '', `${route.path}?table=${newTable}`);
      }
      if (newTable) setTable(newTable);
      registerFullDineInTableChange();
      if (!TABLE_CHANGE_SUCCESS_POPUP_PAGES.includes(route.name)) return;
      _showDialog(app, TABLE_CHANGED_FALG[data.flag]);
      // 换桌成功后删除cartid_tableid,不需要补偿了
      clearCartTableId();
    });
  }, 300);
}

function initTable() {
  const table = route.query.table || getTable();
  if (table) {
    setTable(table, 1000 * 60 * 60 * 12);
  } else {
    clearTable();
  }
}

function registerListenerTableChangeNotice() {
  // 暂时不处理 ID：FULL_DINEIN_NOTICE
  // app.$bus.$off('SHOW_NEW_TABLE');
  // app.$bus.$on('SHOW_NEW_TABLE', (newTable) => {
  // if (!newTable) return;
  // showDialog(app, 517, {}, { callbackPayload: newTable });
  // });
}

// 用户第一次进来清除cart table id，以避免用旧的id，触发换桌弹窗
function maybeClearCardTableId() {
  if (route.name === 'home') {
    clearCartTableId();
  }
}

function testin() {
  const { storeServes, storeInfo, accessStatus } = app;
  if (storeInfo.id in storeServes) {
    store.commit('Menu/updateAccessStatus', storeServes[storeInfo.id]);
  } else {
    const params = {
      ...storeServes,
      [storeInfo.id]: accessStatus || filterValidService(storeInfo),
    };
    store.commit('Menu/updateStoreServes', params);
  }
}
function testunload() {
  document.removeEventListener('visibilitychange', testin);
}

watch(
  () => store.state.Menu.accessStatus,
  (val) => {
    const { storeServes, storeInfo, accessStatus } = app;
    if (storeInfo.id in storeServes) {
      const params = JSON.parse(JSON.stringify(storeServes));
      params[storeInfo.id] = val;
      store.commit('Menu/updateStoreServes', params);
    } else {
      const params = {
        ...storeServes,
        [storeInfo.id]: val || filterValidService(storeInfo),
      };
      store.commit('Menu/updateStoreServes', params);
    }
  },
  { deep: true },
);

function filterValidService(storeInfo) {
  if (!storeInfo.service) return 'DINE_IN';
  if (storeInfo.service.DINE_IN) {
    return 'DINE_IN'
  }
  if (storeInfo.service.PICK_UP) {
    return 'PICK_UP'
  }
  if (storeInfo.service.DELIVERY) {
    return 'DELIVERY'
  }
  return 'DINE_IN'
}

onMounted(async () => {
  document.addEventListener('visibilitychange', testin);
  window.addEventListener('beforeunload', testunload);
  initUser();
  await nextTick();
  initTable();
  maybeClearCardTableId();
  initIcon();
  initFullStory();
  testin();
  await nextTick();
  registerFullDineInTableChange();
  registerListenerTableChangeNotice();
});

onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', testin);
});
Vue.prototype.$reload = reload;
provide('reload', reload);
defineExpose({ reload });
</script>
<style>
#q-app {
  position: relative;
  height: 100%;
}
.grecaptcha-badge {
  visibility: hidden;
  pointer-events: none;
}
</style>
